import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverAttribute } from '../models/credential/driver-attribute.model';
import { Observable, Subject } from 'rxjs';
import { DriverCredentialAttribute } from '../models/credential/driver-credential-attribute.model';
import { DriverAttributeData } from '../models/credential/driver-attribute-data.model';

@Injectable()
export class DriverRestrictionService extends BaseApiService {
    public getLookups = () => this.get('Driver/Restriction/Lookups');

    public getCustomerAttributes = (customerNumberId: number): Observable<{ result: DriverAttributeData[] }> => this.get(`Driver/Restriction/customer/${customerNumberId}`);

    public getActiverDriverCredentialAttributes = (customerNumberId: number): Observable<{ result: DriverCredentialAttribute[] }> => this.get(`Driver/Restriction/customer/Credential/${customerNumberId}`);

    public saveCustomerAttributes = (attributes: DriverAttribute[]): Observable<DriverAttribute[]> => this.post('Driver/Restriction/Customer', attributes);

    public saveRestriction = (model) => this.post('Driver/Restriction/', model);

    public deleteRestriction = (businessTransactionNumberId: number, driverAttributeTypeId: number) => this.delete(`Driver/Restriction/Application/${businessTransactionNumberId}/Restriction/${driverAttributeTypeId}`);

    public getCredentialIssuanceApplicationRestrictions = (businessTransactionNumberId: number) => this.get(`Driver/Restriction/${businessTransactionNumberId}`);

    public deleteDriverRestriction = (customerNumberId: number, driverAttributeTypeId: number): Observable<boolean> => this.delete(`Driver/Restriction/Customer/${customerNumberId}/Attribute/${driverAttributeTypeId}`);

    public deleteDriverCredentialAttribute = (driverCredentialAttributeId: number, customerNumberId: number): Observable<boolean> => this.delete(`Driver/Restriction/CredentialAttribute/${driverCredentialAttributeId}/${customerNumberId}`);

    public getDriverRestriction = (restrictionId: number): Observable<{ result: DriverAttribute }> => this.get(`Driver/Restriction/Attribute/${restrictionId}`);
}
